


















import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class Spinner extends Vue {
  store = this.$store.direct;

  get text() {
    return "Cargando";
  }

  get loading() {
    return this.store.state.loading;
  }
  set loading(val: number) {
    return;
  }
}
